<table>
  <thead *ngIf="!registrantMode">
    <tr>
      <th colspan="5" style="text-align: center">
        <span class="plan-tag">current plan ({{ plan }})</span>
      </th>
    </tr>
    <tr>
      <th></th>
      <th>{{ registrantMode ? 'Selected' : 'Settled' }}</th>
      <th>Unsettled</th>
      <th>Price</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let control of formArray?.controls">
      <tr *ngIf="!registrantMode">
        <td>
          <div class="d-flex flex-row align-items-start">
            <nb-checkbox [ngModel]="control.value.record.active" (ngModelChange)="toggle(control.value.record)" [disabled]="!control.value.record.canBeActivated"></nb-checkbox>
            <mat-icon
              class="arrow-icon"
              style="cursor: pointer"
              [nbTooltip]="!control.value.record.viewBreakdown ? 'View breakdown' : 'Hide breakdown'"
              nbTooltipTrigger="hover"
              nbTooltipPlacement="top"
              (click)="control.value.record.viewBreakdown = !control.value.record.viewBreakdown"
            >
              {{ !control.value.record.viewBreakdown ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
            </mat-icon>
            <span>{{ control.value.record.title }}</span>
          </div>
        </td>
        <td>{{ registrantMode ? control.value.record.selected : control.value.record.settled || 0 }}</td>
        <td>{{ control.value.record.unsettled }}</td>
        <td>{{ control.value.record.price | currency : 'USD' : 'symbol-narrow' : '1.2-2' }}</td>
        <td class="toggle">
          <nb-toggle [ngModel]="control.value.options.auto_settle" (checkedChange)="updateToggleValue($event, control.value.record.title)" status="primary">Auto settle</nb-toggle>
        </td>
      </tr>
      <ng-container *ngIf="control.value.record.viewBreakdown || registrantMode">
        <tr [@fadeInOnEnter] [@fadeOutOnLeave]>
          <th style="text-align: left"></th>
          <th *ngIf="!registrantMode">Settled</th>
          <th>Unsettled</th>
          <th>Each at</th>
          <th>Total</th>
        </tr>
        <tr *ngFor="let subRecord of control.value.record.breakdown" [@fadeInOnEnter] [@fadeOutOnLeave]>
          <td>{{ subRecord.title }}</td>
          <td *ngIf="!registrantMode">{{ subRecord.settled || 0 }}</td>
          <td>{{ registrantMode ? subRecord.selected : subRecord.unsettled }}</td>
          <td>{{ subRecord.eachAt | currency : 'USD' : 'symbol-narrow' : '1.2-2' }}</td>
          <td>{{ subRecord.price | currency : 'USD' : 'symbol-narrow' : '1.2-2' }}</td>
        </tr>
      </ng-container>
    </ng-container>
    <ng-container *ngFor="let settledForm of settledForms">
      <tr>
        <td>
          <div class="d-flex flex-row align-items-start">
            <nb-checkbox [checked]="true" [disabled]="true"></nb-checkbox>
            <span class="form-title">{{ settledForm.form }}</span>
          </div>
        </td>
        <td>{{ settledForm.count }}</td>
        <td>{{ 0 }}</td>
        <td>{{ 0 }}</td>
      </tr>
    </ng-container>
  </tbody>
  <tfoot>
    <tr>
      <td>Total</td>
      <td>{{ (registrantMode ? total.selected || total.unsettled || 0 : total.settled || 0) + (settledTotal || 0) }}</td>
      <td>{{ !registrantMode ? total.unsettled : '' }}</td>
      <td>{{ total.price | currency : 'USD' : 'symbol-narrow' : '1.2-2' }}</td>
      <td></td>
    </tr>
  </tfoot>
</table>
